var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextlevel44(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 76,
    viewBox: "0 0 88 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03674 48.2423V27.3904H10.3363L14.8915 37.5759V27.3904H22.1345V48.2423H14.8915L10.308 37.6042L10.2798 48.2423H3.03674Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9749 48.2423V27.3904H33.0384V42.3574H41.3848V48.2423H24.9749Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3172 48.2423V45.6394H42.8019V40.7447L54.0342 27.3904H62.3524V40.7447H64.6441V45.6394H62.3524V48.2423H54.3172ZM50.243 40.7447H54.3172V35.3124L50.243 40.7447Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4158 48.2423V45.6394H65.9005V40.7447L77.1328 27.3904H85.451V40.7447H87.7427V45.6394H85.451V48.2423H77.4158ZM73.3416 40.7447H77.4158V35.3124L73.3416 40.7447Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.238 45.6583L51.837 37.2201L51.8371 37.2201L48.5201 33.9651L42.8018 40.7636V45.6583H43.238ZM41.3848 47.4769L40.5854 48.2612H24.9748V38.7665L26.5507 37.2202L24.9748 35.6738V27.4093H33.0383V42.3763H41.3848V47.4769ZM22.1345 32.8866V27.4093H16.5528L22.1345 32.8866ZM11.5806 51.9102H36.867L12.6432 75.6809L0 63.2742L11.5806 51.9102ZM12.8343 23.7604H36.6872V38.7274H39.7465L45.908 31.4018L39.1939 24.8134L39.1939 24.8135L13.9074 0L1.26421 12.4067L12.8343 23.7604ZM15.2991 48.2612L22.1345 41.5538V48.2612H15.2991ZM50.6682 50.1333V51.9102H66.0012V49.3072H73.7668V51.9102H74.1438L49.92 75.6809L37.2768 63.2742L50.6682 50.1333ZM85.5028 40.7636L77.8622 48.2612H77.4157V45.6583H65.9004V40.7636L77.1328 27.4093H79.116L85.4509 33.6257V40.7636H85.5028ZM75.4174 23.7799L51.1842 3.17401e-05L38.541 12.4067L51.3295 24.9561L52.3353 23.7604H66.0012V34.9749L75.4174 23.7799ZM53.9416 27.5193L62.3523 35.7727V27.4093H54.0342L53.9416 27.5193ZM62.3523 38.6677V40.7636H64.6441V45.6583H62.3523V48.2612H54.3171V46.5526L62.3523 38.6677ZM77.4157 40.7636H73.3415L77.4157 35.3313V40.7636Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextlevel44);
export default __webpack_public_path__ + "static/media/nextlevel44.463d25bc0445ec8cecc39441d3923c50.svg";
export { ForwardRef as ReactComponent };